export default "__VITE_ASSET__gQ74N9$C__"